module.exports = __webpack_public_path__ + "static/media/upgrade-24px.1ea55b5b.svg";